import React from 'react';

import { Box, FormikField, Label, RadioGroup, Text } from '@betterment/samba-react';

const RecommendedBadge = () => (
  <Box
    as="span"
    css={{
      display: 'inline-block',
      px: 'space.100',
      py: 'space.25',
      borderRadius: 'full',
      bg: 'background.selected',
      ml: 'space.100',
    }}
  >
    <Text variant="text50" color="text">
      Recommended
    </Text>
  </Box>
);

export const AgreementMethodSection: React.FC = () => (
  <Box
    css={{
      p: 'space.300',
      borderColor: 'border.weak',
      borderStyle: 'solid',
      borderWidth: 'thin',
      borderRadius: 'medium',
    }}
  >
    <FormikField name="agreementMethod">
      <FormikField.Control>
        <RadioGroup aria-labelledby="agreementMethodLabel" css={{ gap: '0' }}>
          <Label id="agreementMethodLabel" css={{ pb: 'space.200' }}>
            <Text variant="text100" css={{ fontWeight: 'medium' }}>
              Agreement method
            </Text>
          </Label>

          <RadioGroup.ItemContainer>
            <RadioGroup.Item value="docusign" id="docusign" />
            <RadioGroup.ItemLabel>
              <Box css={{ display: 'inline-flex', alignItems: 'center' }}>
                Digital signature with DocuSign
                <RecommendedBadge />
              </Box>
            </RadioGroup.ItemLabel>
          </RadioGroup.ItemContainer>
          <Box css={{ pl: '28px', mt: 'space.50' }}>
            <Text variant="text100" color="text.weak">
              New clients will sign this agreement digitally before their account is created. This provides the most
              streamlined experience and ensures signatures are collected automatically.
            </Text>
            <Text variant="text100" color="text.weak" css={{ mt: 'space.100' }}>
              Requires document setup with our support team (typically 2-3 business days).
            </Text>
          </Box>

          <RadioGroup.ItemContainer css={{ mt: 'space.300' }}>
            <RadioGroup.Item value="checkbox_consent" id="checkbox_consent" />
            <RadioGroup.ItemLabel>Checkbox consent</RadioGroup.ItemLabel>
          </RadioGroup.ItemContainer>
          <Box css={{ pl: '28px', mt: 'space.50' }}>
            <Text variant="text100" color="text.weak">
              New clients will review the document during onboarding and agree electronically by checking a box. No
              signature is collected. Uploads instantly.
            </Text>
          </Box>
        </RadioGroup>
      </FormikField.Control>
      <FormikField.ErrorMessage />
    </FormikField>
  </Box>
);
